"use client";

import React, { useEffect, useState } from "react";
import ButtonClose from "@/components/ButtonClose/ButtonClose";
import Logo from "@/components/Logo/Logo";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@/app/headlessui";
import { NavItemType } from "./NavigationItem";
import SocialsList from "@/components/SocialsList/SocialsList";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import SwitchDarkMode from "@/components/SwitchDarkMode/SwitchDarkMode";
import { Route } from "next";
import { useRouter } from "next13-progressbar";
import { usePathname } from "next/navigation";
import { DatePicker, Select } from "antd";
import { mockNewsArchiveCategories } from "@/data/mockNewsArchiveCategories";
import { CalendarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

export interface NavMobileProps {
  data?: NavItemType[];
  onClickClose?: () => void;
}

const NavMobile: React.FC<NavMobileProps> = ({ data = [], onClickClose }) => {
  const router = useRouter();
    const pathname = usePathname();
  
  // Get initial edition from URL
  const initialSlug = pathname?.split("/")[1] || "";
  const initialEdition = mockNewsArchiveCategories.find(
    (e) => e.slug === initialSlug
  );
  const [selectedEdition, setSelectedEdition] = useState(
    initialEdition?.name || "Edition"
  );
  const [selectedSlug, setSelectedSlug] = useState(initialEdition?.slug || "");
    const handleEditionChange = (value: string | null, option: any) => {
      if (!value) {
        // Handle clear
        setSelectedEdition("Edition");
        setSelectedSlug("");
        router.push("/");
        return;
      }
  
      const edition = mockNewsArchiveCategories.find((e) => e.id === value);
      if (edition) {
        setSelectedEdition(edition.name);
        setSelectedSlug(edition.slug);
        router.push(`/${edition.slug}`);
      }
    };
  
    const handleDateChange = (date: dayjs.Dayjs | null) => {
      if (date && selectedSlug) {
        const formattedDate = date.format("YYYY-MM-DD");
        router.push(`/${selectedSlug}/${formattedDate}`);
      }
    };
  return (
    <div className="overflow-y-auto w-full h-screen py-2 transition transform shadow-lg ring-1 dark:ring-neutral-700 bg-white dark:bg-neutral-900 divide-y-2 divide-neutral-100 dark:divide-neutral-800">
      <div className="py-6 px-5">
        <Logo />

        <span className="absolute end-2 top-2 p-1">
          <ButtonClose aria-label="Close mobile menu" onClick={onClickClose} />
        </span>

        {/* <div className="mt-5">{renderSearchForm()}</div> */}
        <ul className="flex flex-col py-6 px-2 space-y-1 rtl:space-x-reverse">
          <Select
            value={initialEdition?.id || undefined}
            allowClear
            placeholder="Select Edition"
            style={{ width: 160 }}
            onChange={handleEditionChange}
            options={mockNewsArchiveCategories.map((edition) => ({
              value: edition.id,
              label: edition.name,
            }))}
            className="!w-full "
          />

          {/* Date Picker */}
          <div className="block">
            <DatePicker
              onChange={handleDateChange}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
              allowClear={true}
              className=" w-full !h-full !py-2"
            />
          </div>

       
        </ul>
      </div>
    </div>
  );
};

export default NavMobile;
